import {
  FieldLabel,
  getFontCss,
  styleConstants,
  Tag,
  TagScales,
  themeConstants,
} from '@paywithextend/components'
import moment from 'moment'
import React from 'react'
import Box from 'src/components/Box/Box'
import SvgOrganizationFilled from 'src/components/Svgs/SvgOrganizationFilled'
import Trns from 'src/localization/Trns'
import { OrganizationsListModel } from 'src/models/organizations.models'
import { UserListModel } from 'src/models/user.models'
import styled, { css } from 'styled-components'

interface OrganizationBoxProps {
  user: UserListModel
  organization: OrganizationsListModel
}

export type EmployeeInfoFlatFields = {
  employeeId?: string
}

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`

const OrganizationBox: React.FC<OrganizationBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <Box
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            20,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 37px;
        `}
      >
        <Trns source={'Organization'} />
      </div>
      <StyledDiv>
        <FieldLabel>
          <Trns source={'Organization Name'} />
        </FieldLabel>
        {props.organization.name}
      </StyledDiv>
      <StyledDiv>
        <FieldLabel>
          <Trns source={'Joined'} />
        </FieldLabel>
        {moment(props.user.organization.joinedAt).format('MM/DD/YYYY')}
      </StyledDiv>
      <StyledDiv>
        <FieldLabel>
          <Trns source={'Role'} />
        </FieldLabel>
        <div>
          <Tag
            text={<Trns source={props.user.orgRoleDisplayTagTitle} />}
            icon={
              props.user.hasOrgOwnerPermissions ? (
                <SvgOrganizationFilled style={TagScales.medium} />
              ) : undefined
            }
          />
        </div>
      </StyledDiv>
    </Box>
  )
}

export default OrganizationBox
